const { isVehicleElectricOrHybridCar, } = require('./vehicle-helper');

const getPropMaxMileage = (prop, vehicle) => {
    let maxMileage = prop.maxMileage ? prop.maxMileage : Infinity;

    if (isVehicleElectricOrHybridCar(vehicle)) {
        if (prop.maxMileageAtStartElectricCar > 0) {
            maxMileage = prop.maxMileageAtStartElectricCar;
        }
    }

    return maxMileage;
};

const getPropMaxVehicleAgeAtEnd = (prop, vehicle) => {
    let maxVehicleAgeAtEnd = prop.maxVehicleAgeAtEnd ? prop.maxVehicleAgeAtEnd : Infinity;

    if (isVehicleElectricOrHybridCar(vehicle)) {
        if (prop.maxVehicleAgeAtEndElectricCarMonths > 0) {
            maxVehicleAgeAtEnd = prop.maxVehicleAgeAtEndElectricCarMonths;
        }
    }

    return maxVehicleAgeAtEnd;
};

module.exports = {
    getPropMaxMileage,
    getPropMaxVehicleAgeAtEnd,
};